module.exports = __webpack_public_path__ + "img/empty-state-2.90d4d352.svg";